import React, { useState } from "react";
import { PlayCircle, Film } from "lucide-react";
import { toEmbed, ytThumb } from "../data/videos";

// Drop in a YouTube / Vimeo / Mux URL to `src`. If `src` is empty, a premium
// placeholder is shown with a poster image + Play overlay (great during dev).
export default function VideoSection({
  src = "",
  poster = "/homes/aintree/5.jpg",
  eyebrow = "Watch",
  title = "A 60-second look at Alpha.",
  subtitle = "Who we are, how we work, and why families choose us.",
  testid = "video-section",
}) {
  const [playing, setPlaying] = useState(false);
  const embedSrc = toEmbed(src);
  const resolvedPoster = src ? (ytThumb(src) || poster) : poster;

  return (
    <section className="alpha-section" data-testid={testid}>
      <div className="alpha-container">
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-5 alpha-reveal">
            <div className="alpha-overline"><Film className="w-3.5 h-3.5 inline -mt-0.5 mr-1.5" />{eyebrow}</div>
            <h2 className="mt-3 font-display text-3xl sm:text-[40px] font-medium tracking-tight leading-[1.05]">
              {title}
            </h2>
            <p className="mt-3 text-[color:var(--alpha-mute)] max-w-md text-[15px]">{subtitle}</p>
          </div>
          <div className="lg:col-span-7 alpha-reveal">
            <div className="relative rounded-3xl overflow-hidden aspect-video shadow-2xl ring-1 ring-[color:var(--alpha-line-strong)] group">
              {playing && embedSrc ? (
                <iframe
                  title="Alpha video"
                  src={embedSrc}
                  className="absolute inset-0 w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              ) : (
                <>
                  <img src={resolvedPoster} alt="" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" />
                  <div className="absolute inset-0 bg-gradient-to-br from-[#2F1A5C]/65 via-[#2F1A5C]/25 to-transparent" />
                  <button
                    type="button"
                    onClick={() => embedSrc && setPlaying(true)}
                    className="absolute inset-0 flex items-center justify-center"
                    aria-label="Play video"
                    data-testid="video-play-btn"
                  >
                    <span className="relative w-20 h-20 md:w-24 md:h-24 rounded-full bg-white/95 text-[color:var(--alpha-purple-700)] flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform alpha-chat-pulse">
                      <PlayCircle className="w-12 h-12 md:w-14 md:h-14" strokeWidth={1.25} />
                    </span>
                  </button>
                  <div className="absolute left-5 bottom-5 text-white">
                    <div className="text-[11px] tracking-[0.22em] uppercase text-white/75">Alpha Community Care</div>
                    <div className="font-display font-semibold text-base md:text-lg !text-white">{title}</div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
